// JsFromRoutes CacheKey 54a9d29de05f132b4106dec48680c1ef
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  updateCategory: /* #__PURE__ */ definePathHelper('patch', '/consumer/user_gift_preferences/update_category'),
}
